<template>
  <section class="couponCode">
    <template v-if="couponCode !='' && couponCode != undefined && couponCode !=null ">
      <div class="couponCode-bg">
          <div class="couponCode-container">
            <div class="logoText"></div>
            <div class="enterCodeTip">
                <p>打开海渡职校APP</p>
                <p>在优惠券左栏中输入</p>
                <div class="theCode">{{couponCode}}</div>
                <span>即可获得优惠券</span>
            </div>
            <img src="~assets/images/share/image_text.png" alt="" class="barCodeText">
            <img :src="obj.url" alt="" class="barCode">
            <div class="downloadApp">
                <p>长按二维码，下载<span> 海渡职校 </span>APP</p>
                <p>领取优惠券</p>
            </div>
            <!-- 左右半圆 -->
            <p class="couponCode-left circlePart"></p>
            <p class="couponCode-right circlePart"></p>
            <p class="dashedLine"></p>
          </div>
      </div>
    </template>
    <template v-else>
      <h1 style="text-align: center;margin-top:50%;">您的链接缺少优惠码信息,请确认后重试</h1>
    </template>
  </section>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      couponCode: '',
      obj: {
        url: ''
      }
    }
  },
  mounted() {


  },
  created() {
    this.couponCode = this.$route.query.couponCode;  //接收url的优惠码参数
    this.getBarCode();
  },
  methods: {
    getBarCode(){   //获取下载app的二维码
        axios.post('/haidu/api/codeInfo/wxQr').then(res=>{
            if(res.data.success){
                this.obj.url = res.data.data
            }
        })
    }
  }
}

</script>
<style lang="scss" scoped>
.couponCode{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}
.couponCode-bg{
    width: 100%;
    height: 100%;
    background-color: #006bff;
    position: relative;
    .couponCode-container{
        width: 9.2533rem;
        height: 15.1733rem;
        border-radius: 14px;
        background: #fff url(~assets/images/share/img_bg.png) bottom no-repeat;
        background-size:contain;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        .circlePart{
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            background-color: #006bff;
        }
        .couponCode-left{
            position: absolute;
            left: -0.2rem;
            top: 50%;
            margin-top: -0.2rem;
        }
        .couponCode-right{
            position: absolute;
            right: -0.2rem;
            top: 50%;
            margin-top: -0.2rem;
        }
        .dashedLine{
            width: 8.3866rem;
            height: 0;
            border-top: 2px dashed #006bff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }
    }
}
.logoText{
    width: 3.12rem;
    height: 0.6533rem;
    margin: 1.1466rem auto 0.533rem;
    background: url(~assets/images/share/logoTexts.png) no-repeat;
    background-size: cover;
}
.enterCodeTip {
    text-align: center;
    p{
        font-size:0.4534rem;
        height: 0.78rem;
        line-height: 0.78rem;
        color: #006bff;
    }
    div{
        margin: 0.5734rem auto;
        width: 3.52rem;
        height: 1.12rem;
        line-height: 1.12rem;
        border-radius: 10px;
        background-color: #006bff;
        font-size:0.46rem;
        font-weight: 700;
        color: #fff;
    }
}
.barCodeText{
    display: block;
    width: 4.48rem;
    margin: 1.4rem auto 0.28rem;
}
.barCode{
    display: block;
    width: 4.3066rem;
    height: 4.3066rem;
    border: 1px solid #000;
    margin: 0 auto;
}
.downloadApp{
    text-align: center;
    font-size: 0.34rem;
    line-height: 0.55rem;
    margin-top: 0.24rem;
    p{
        height: 0.55rem;
    }
    span{
        color: #006bff;
    }
}



</style>



// WEBPACK FOOTER //
// CouponCode.vue?363942b0